<div [class.open]="open" class="loading-spinner--wrapper">
    <div class="loading-spinner">
        <inc-spinner></inc-spinner>
    </div>
</div>